/**
 * MobileMenu
 * Collapsible navigation shown on small screens. Keep the `menus` array in sync
 * with the desktop nav in Header (currently Home / About / Contact).
 */
import React, { Component } from 'react';
import { Collapse, CardBody, Card } from 'reactstrap';
import { Link } from 'react-router-dom';
import './style.css';

const menus = [
  {
    id: 1,
    title: 'Home',
    link: '/home',
  },
  {
    id: 2,
    title: 'About',
    link: '/about',
  },
  {
    id: 3,
    title: 'Contact',
    link: '/contact',
  },
];

export default class MobileMenu extends Component {
  state = {
    isMenuShow: false,
    isOpen: 0,
  };

  menuHandler = () => {
    this.setState({ isMenuShow: !this.state.isMenuShow });
  };

  setIsOpen = (id) => () => {
    this.setState({ isOpen: id === this.state.isOpen ? 0 : id });
  };

  render() {
    const { isMenuShow, isOpen } = this.state;

    const ClickHandler = () => {
      window.scrollTo(10, 0);
    };

    return (
      <div className="mobile-menu-wrapper">
        <div className={`mobileMenu ${isMenuShow ? 'show' : ''}`}>
          <ul className="responsivemenu">
            {menus.map((item) => (
              <li key={item.id}>
                {item.submenu ? (
                  <button
                    onClick={this.setIsOpen(item.id)}
                    className="submenu-toggle"
                    aria-expanded={item.id === isOpen}
                  >
                    {item.title}
                    <i className="fa fa-angle-right" aria-hidden="true"></i>
                  </button>
                ) : (
                  <Link to={item.link} onClick={ClickHandler}>
                    {item.title}
                  </Link>
                )}
                {item.submenu && (
                  <Collapse isOpen={item.id === isOpen}>
                    <Card>
                      <CardBody>
                        <ul>
                          {item.submenu.map((submenu) => (
                            <li key={submenu.id}>
                              <Link onClick={ClickHandler} to={submenu.link}>
                                {submenu.title}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </CardBody>
                    </Card>
                  </Collapse>
                )}
              </li>
            ))}
          </ul>
        </div>

        <button
          className="showmenu"
          onClick={this.menuHandler}
          aria-label={isMenuShow ? 'Close menu' : 'Open menu'}
          aria-expanded={isMenuShow}
        >
          <i className="fa fa-bars" aria-hidden="true"></i>
        </button>
      </div>
    );
  }
}
